import React from 'react'

const NoPage = () => {
  return (
    <div>404 NoPage</div>
  )
}

export default NoPage